const Email_form = require('../home/common/email-form'),
  formatters = require('../common/formatters')

require('../home/form')

$(function() {
  Email_form()

  const $wesave_circle = $('#comparator-wesave-circle'),
    $other_circle = $('#comparator-other-circle'),
    $total_amount = $('#comparator-total-amount'),
    $wesave_amount = $('#comparator-wesave-amount'),
    $other_amount = $('#comparator-other-amount'),
    $comparator_slider = $('#comparator-slider')

  function update_comparator () {
    const total_value = $(this).val()*2000 + 10000,
      wesave_value = total_value * 0.015,
      other_value = total_value * 0.094

    $total_amount.text(formatters.human_readable_number(total_value) +' €')
    $wesave_amount.text(formatters.human_readable_number(Math.round(wesave_value/12)) + ' €')
    $other_amount.text(formatters.human_readable_number(Math.round(other_value/12)) +' €')

    $other_circle.css({width: (100+other_value/50)+'px', height: (100+other_value/50)+'px'});
    $wesave_circle.css({width: (100+wesave_value/50)+'px', height: (100+wesave_value/50)+'px'});
    $comparator_slider.siblings('span').width($(this).val() + '%')
  }

  $comparator_slider.on('input change', update_comparator)

  update_comparator.apply($comparator_slider)
})
